import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";
import MenuView from "@/views/common/MenuView";
import PageView from "@/views/common/PageView";
import LoginView from "@/views/login/Login";
import EmptyPageView from "@/views/common/EmptyPageView";
import TenantLogin from "@/views/business/tenantlogin/TenantLogin";
import FindPassWord from "@/views/findpassword/findpassword";
import UpdatePassWord from "@/views/findpassword/updatepassword";
import bigScreen from "@/views/bigscreen/bigScreen";
// import FindPassWord from '@/views/login/Regist'
// import HomePageView from '@/views/HomePage'
import db from "utils/localstorage";
import request from "utils/request";
import { rejects } from "assert";

Vue.use(Router);

let constRouter = [
  {
    path: "/login/:id",
    name: "login",
    component: LoginView
  },
  {
    path: "/index",
    name: "首页",
    redirect: "/map"
  },
  {
    path: "/login", //输入链接无租户名的跳转此组件
    name: "tenantLogin",
    component: TenantLogin
  },
  {
    path: "/updatepassword",
    name: "updatepassword",
    component: UpdatePassWord
  },
  {
    path: "/findpassword",
    name: "findpassword",
    component: FindPassWord
  },
  {
    path: "/bigscreen",
    name: "bigScreen",
    component: bigScreen
  }
];

let router = new Router({
  // mode: 'history',
  routes: constRouter
});

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

// router.$addRoutes = (params) => {
//   router.matcher = new Router().matcher
//   router.addRoutes(params)
// }

const whiteList = "/login";
export let loginParamId = "";

let asyncRouter = [];
let hasRouter = false;

// 导航守卫，渲染动态路由
router.beforeEach((to, from, next) => {
  console.log(to);
  console.log(from);
  if (to.path == "/updatepassword") {
    next();
    // if (to.path == '/updatepassword') { next() }
  } else if (to.path == "/findpassword" || to.path == "") {
    next();
  } else if (to.path.includes(whiteList) && !!to.params.id) {
    // console.log(111)
    //监测该租户url是否存在
    checkLoginUrl(to).then(res => {
      if (res.data) {
        // console.log(db.get('loginParamId'))
        // console.log(to.params.id)
        if (!hasRouter) {
          db.clear();
        }
        loginParamId = to.params.id;
        let systemName = res.data.systemName;
        let systemLogo = res.data.systemLogo;
        if (loginParamId != db.get("loginParamId")) {
          //直接更改链接，需重新获取菜单
          asyncRouter = [];
          db.clear();
        }
        db.save("loginParamId", loginParamId);
        db.save("systemName", systemName);
        db.save("systemLogo", systemLogo);
        store.commit("setting/setSystemIcon", systemLogo);
        store.commit("setting/setSystemName", systemName);
        document.title = systemName;
        // asyncRouter = []
        next();
      } else {
        //不存在
        next("/login");
      }
    });
  } else if (to.path.includes(whiteList) && !to.params.id) {
    loginParamId = "";
    db.save("loginParamId", loginParamId);
    next();
  } else {
    let token = db.get("USER_TOKEN");
    let user = db.get("USER");
    let userRouter = get("USER_ROUTER");
    let loginId = loginParamId ? loginParamId : db.get("loginParamId");
    if (token && user) {
      // 有token 且 有用户信息，则进行获取路由信息
      if (asyncRouter.length == 0) {
        // 异步路由是否为空
        if (!userRouter) {
          // 用户路由是否为空
          // 发送请求获取用户的路由菜单
          request.get(`menu/${user.userName}`).then(res => {
            console.log(res);
            asyncRouter = res.data;
            db.save("USER_ROUTER", asyncRouter);
            hasRouter = true;
            go(to, next);
          });
        } else {
          asyncRouter = userRouter; // 同步，再跳转
          go(to, next);
        }
      } else {
        next();
      }
    } else {
      console.log(333);
      // 没有token没有用户信息直接跳转去login页面
      if (loginId) {
        hasRouter = false;
        next("/login/" + loginId);
      } else {
        next("/login");
      }
    }
  }
});

function checkLoginUrl(to) {
  console.log(to);
  let p = new Promise((resolve, reject) => {
    request
      .post("/checkLoginUrl", {
        tenantName: to.params.id
      })
      .then(res => {
        console.log(res);
        resolve(res);
      });
  });
  return p;
}

/**
 * 封装了放行的处理，实际上里头做了asyncRouter的component（字符串）替换真实component实例，
 * 然后将替换后的asyncRouter,加到常量定义的基础router中，生成登录验证后的权限路由表
 * @param {*} to
 * @param {*} next
 */
function go(to, next) {
  asyncRouter = filterAsyncRouter(asyncRouter);
  router.addRoutes(asyncRouter);
  // router.$addRoutes(asyncRouter)
  next({ ...to, replace: true });
}

/**
 * localStorage设置key-value的方法封装，将json对象的data转为字符串value保存
 * @param {*} name
 * @param {*} data
 */
function save(name, data) {
  localStorage.setItem(name, JSON.stringify(data));
}
/**
 * localStorage根据key，获取value的方法封装，将字符串转为json对象，并返回
 * @param {*} name
 */
function get(name) {
  return JSON.parse(localStorage.getItem(name));
}
/**
 * routes（json对象）的component的属性值（字符串）替换为真正vue界面实例
 * @param {*} routes
 */
function filterAsyncRouter(routes) {
  return routes.filter(route => {
    let component = route.component;
    if (component) {
      switch (route.component) {
        case "MenuView":
          route.component = MenuView;
          break;
        case "PageView":
          route.component = PageView;
          break;
        case "EmptyPageView":
          route.component = EmptyPageView;
          break;
        // case 'HomePageView':
        //   route.component = HomePageView
        //   break
        default:
          route.component = view(component);
      }
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children);
      }
      return true;
    }
  });
}
/**
 * 匹配指定路径下是否存在组件的vue文件，如果是存在的则导入并返回组件实例
 * 注意：
 * 对于项目中新建vue文件，如需要动态导入的界面，
 * 必须重启当前vue项目，动态import才会生效，否则会提示找不到这个vue文件
 * @param {*} path
 */
function view(path) {
  return function(resolve) {
    import(`@/views/${path}.vue`).then(mod => {
      resolve(mod);
    });
  };
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js